export { TinRegistrationStatusHeader } from './TinRegistrationStatusHeader';
